var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "ifill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.8566 8.33798C11.3747 7.63977 11.5605 6.90392 10.9745 6.25438C9.65955 4.41441 8.77521 3.27657 8.22051 2.72861C7.16595 1.68688 5.43118 1.82779 4.51785 2.72772C4.0273 3.21109 3.86122 3.37707 3.35753 3.88869C0.551877 6.69584 2.26291 12.6301 6.81145 17.1831C11.359 21.7351 17.2926 23.447 20.1042 20.6339C20.569 20.1858 20.9625 19.7921 21.2729 19.4641C22.1679 18.518 22.3038 16.8598 21.267 15.7825C20.7354 15.2302 19.6504 14.3885 17.733 13.017C17.1457 12.4919 16.4495 12.6057 15.8111 13.0245C15.504 13.226 15.2806 13.4298 14.8586 13.8521L14.0924 14.6188C13.9914 14.7198 12.621 14.0335 11.2908 12.7019C9.95978 11.3696 9.27396 9.99914 9.37441 9.89869L10.1412 9.1315C10.2751 8.99749 10.3391 8.93261 10.4211 8.84635C10.5921 8.66662 10.7337 8.50351 10.8566 8.33798ZM15.5058 16.033L16.2722 15.2662C16.5044 15.0337 16.6549 14.8908 16.7774 14.7923C18.457 15.9985 19.4298 16.7569 19.8271 17.1698C20.0657 17.4176 20.0286 17.8699 19.8212 18.0891C19.5342 18.3925 19.1614 18.7655 18.7038 19.2069C16.8858 21.0257 12.096 19.6438 8.22519 15.7692C4.35321 11.8934 2.97194 7.10287 4.77626 5.29756C5.27792 4.78805 5.43686 4.62919 5.92042 4.15273C6.10172 3.97408 6.59558 3.93397 6.81614 4.15184C7.2432 4.57371 8.0354 5.58807 9.20077 7.21141C9.14044 7.2863 9.06509 7.37095 8.97339 7.46732C8.90609 7.53805 8.85002 7.59489 8.72744 7.71759L7.96142 8.48403C6.65827 9.78707 7.76808 12.0048 9.87703 14.1158C11.9845 16.2254 14.2031 17.3364 15.5058 16.033Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }